'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/routing';
import { useAuth } from '@/contexts/auth-context';
import { isSuperAdmin, hasAnyPermission } from '@/features/auth';
import { useFirstAccessibleRoute } from '@/hooks/use-nav';
import { DashboardOverview } from '@/features/dashboard';
import { Loader2 } from 'lucide-react';

export default function DashboardPage() {
  const { user } = useAuth();
  const router = useRouter();
  const firstRoute = useFirstAccessibleRoute();

  const canViewDashboard =
    !user || isSuperAdmin(user) || hasAnyPermission(user, ['dashboard.view']);

  useEffect(() => {
    if (user && !canViewDashboard && firstRoute !== '/dashboard') {
      router.replace(firstRoute);
    }
  }, [user, canViewDashboard, firstRoute, router]);

  if (!user || (!canViewDashboard && firstRoute !== '/dashboard')) {
    return (
      <div className='flex min-h-[60vh] items-center justify-center'>
        <Loader2 className='h-8 w-8 animate-spin' />
      </div>
    );
  }

  return <DashboardOverview />;
}
